import Link from "../utils/Link";
import React from "react";
import Content from "../common/Content";
import TopBox from "../common/TopBox";
import Paragraph from "../common/Paragraph";
import FormBox from "../form/FormBox";
import buildForm from "../form/buildForm";
import * as yup from "yup";
import { Field } from "../form/input/Field";
import Dropdown, { DropdownOption } from "../form/input/Dropdown";
import FormCheckbox from "../form/input/FormCheckbox";
import A from "../common/A";
import Label from "../common/Label";
import Legend from "../common/Legend";
import { classicFormSubmit } from "../form/classicFormSubmit";
import { FlexRow } from "../common/Flex";
import { fontSizing } from "../theme";
import styled from "styled-components";
import { Error } from "../form/input/Input";
import CustomPageHead from "../common/CustomPageHead";

export const htmlTitleNewsletterSubscribe = "Newsletter-Anmeldung";

const Small = styled.span`
  ${fontSizing("label", 18)}
`;

const StyledFieldSet = styled.fieldset`
  border: 0 none;
`;

const Form = buildForm({
  initialValues: {
    salutation: "none",
    lastname: "",
    firstname: "",
    email: "",
    datenschutz: false,
    wohnraum: false,
    umwelt: false,
    wirtschaft: false,
    innovation: false,
    "226570": ""
  },
  fieldSchema: {
    salutation: yup.string(),
    firstname: yup.string(),
    lastname: yup.string(),
    "226570": yup.string(),
    email: yup.string().required("Bitte ausfüllen"),
    datenschutz: yup
      .boolean()
      .required("Pflichtfeld")
      .notOneOf([false], "Bitte auswählen")
  },
  handleSubmit: async ({
    wohnraum,
    umwelt,
    wirtschaft,
    innovation,
    ...values
  }) => {
    const data: { "226570": string[]; [s: string]: string | string[] } = {
      "226570": []
    };
    Object.entries(values).map(([k, v]) => {
      data[k] = typeof v === "boolean" ? (v ? "1" : "0") : v;
    });
    data["226570"] = [];
    if (wohnraum) {
      data["226570"].push("Wohnraum");
    }
    if (umwelt) {
      data["226570"].push("Umwelt");
    }
    if (wirtschaft) {
      data["226570"].push("Wirtschaft");
    }
    if (innovation) {
      data["226570"].push("Innovation");
    }
    classicFormSubmit("https://eu.cleverreach.com/f/12336-11176/wcs/", data);
  },
  validate: values => {
    if (
      values.wohnraum ||
      values.umwelt ||
      values.wirtschaft ||
      values.innovation
    ) {
      return;
    }
    return {
      "226570": "Bitte auswählen"
    };
  }
});
const SubscribePage = () => (
  <>
    <CustomPageHead title={htmlTitleNewsletterSubscribe} />
    <TopBox
      title="Auf dem Laufenden bleiben?"
      intro="Sie möchten aktuelle Informationen zur Förderung in Hamburg und interessanten Veranstaltungen der IFB Hamburg? Bleiben Sie auf dem Laufenden mit dem Newsletter der IFB Hamburg."
      breadCrumpPath={[
        {
          route: "newsletterSubscribe",
          title: "Newsletter"
        }
      ]}
    />
    <Content padded as="main">
      <FormBox>
        <Form submitLabel="Absenden">
          {props => {
            return (
              <>
                <Field
                  name="salutation"
                  label="Anrede"
                  component={Dropdown}
                  id={"salutation"}
                  autoComplete="honorific-prefix"
                  placeHolderText={"Bitte Anrede auswählen"}
                >
                  <DropdownOption value="none" disabled>
                    Bitte wählen
                  </DropdownOption>
                  <DropdownOption value="Frau">Frau</DropdownOption>
                  <DropdownOption value="Herr">Herr</DropdownOption>
                </Field>
                <Field
                  name="firstname"
                  type="text"
                  label="Vorname"
                  id={"firstname"}
                  autoComplete="given-name"
                  placeholderText={"Bitte Vornamen eingeben"}
                />
                <Field
                  name="lastname"
                  type="text"
                  label="Nachname"
                  id={"lastname"}
                  autoComplete="family-name"
                  placeholderText={"Bitte Nachnamen eingeben"}
                />
                <Field
                  name="email"
                  type="email"
                  label="E-Mail"
                  id={"email"}
                  autoComplete="email"
                  aria-describedby={"email-error"}
                  placeholderText={"Bitte E-Mail Adresse eingeben"}
                  necessaryFieldText="Diese Information wird benötigt"
                />
                <StyledFieldSet>
                  <Legend big>
                    Ich interessiere mich insbesondere für folgende
                    Themenbereiche*:
                  </Legend>
                  {(props.touched.wohnraum ||
                    props.touched.wirtschaft ||
                    props.touched.umwelt ||
                    props.touched.innovation) &&
                    props.errors["226570"] && (
                      <Error id={"subjects-error"} isError>
                        {props.errors["226570"]}
                      </Error>
                    )}
                  <FlexRow flexWrap justifyContent="space-between">
                    <Field
                      name="wohnraum"
                      component={FormCheckbox}
                      label="Wohnraum"
                      aria-describedby={"subjects-error"}
                    />
                    <Field
                      name="umwelt"
                      component={FormCheckbox}
                      label="Umwelt"
                      aria-describedby={"subjects-error"}
                    />
                    <Field
                      name="wirtschaft"
                      component={FormCheckbox}
                      label="Wirtschaft"
                      aria-describedby={"subjects-error"}
                    />
                    <Field
                      name="innovation"
                      component={FormCheckbox}
                      label="Innovation"
                      aria-describedby={"subjects-error"}
                    />
                  </FlexRow>
                </StyledFieldSet>
                <Paragraph tiny>
                  Ihre hier eingegebenen Daten werden lediglich zur
                  Personalisierung des Newsletters der IFB Hamburg verwendet.
                  Ihre Daten werden nicht an Dritte weitergegeben. Weitere
                  Informationen zum Thema Datenschutz erhalten Sie in unserer{" "}
                  <Link route="dataPrivacy">
                    <A tabIndex={0}>Datenschutzerklärung</A>
                  </Link>
                  . Durch Absenden der von Ihnen eingegebenen Daten willigen Sie
                  in den Empfang des Newsletters ein und bestätigen die
                  Datenschutzerklärung.
                </Paragraph>
                <Field
                  name="datenschutz"
                  component={FormCheckbox}
                  value={"1"}
                  id={"newsletter-privacy"}
                  aria-describedby={"newsletter-privacy-error"}
                  label={
                    <Small>
                      Ja, ich möchte den Newsletter der IFB Hamburg abonnieren.
                      Ich erhalte nun kostenlos rund sechsmal im Jahr aktuelle
                      Informationen zur öffentlichen Förderung in Hamburg.
                      Abmelden kann ich mich jederzeit über den Abmelde-Link im
                      Newsletter.
                    </Small>
                  }
                />
              </>
            );
          }}
        </Form>
      </FormBox>
    </Content>
  </>
);

export default SubscribePage;
